import Navbar from "./components/navbar/Navbar"
import Header from "./components/header/Header"
import Main from "./components/main/Main"
import {buttons, data} from "./helper/data"
import "./components/scss/app.scss"



function App() {
  
  return (
   <>
   
    <Header buttons={buttons}/>
    <Main data = {data}/>
   </>
  );
}

export default App;
